import BaseComponent from 'bootstrap/js/src/base-component.js';
import EventHandler from 'bootstrap/js/src/dom/event-handler.js';
import SelectorEngine from 'bootstrap/js/src/dom/selector-engine.js';
import { defineJQueryPlugin } from 'bootstrap/js/src/util/index.js';

const NAME = 'accordionScroll';
const EVENT_SHOWN = 'shown.bs.collapse';
const SELECTOR_ACCORDION = '.accordion';
const SELECTOR_ITEM = '.accordion-item';
const SELECTOR_HEADER = '.accordion-header';

class AccordionScroll extends BaseComponent {
  _onShown(e) {
    const item = e.target.closest(SELECTOR_ITEM);
    if (!item) return;

    const header = SelectorEngine.findOne(SELECTOR_HEADER, item);
    if (!header) return;

    const rect = header.getBoundingClientRect();
    if (rect.top < 0) {
      header.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  static get NAME() {
    return NAME;
  }

  static jQueryInterface(config) {
    return this.each(function () {
      AccordionScroll.getOrCreateInstance(this, config);
    });
  }
}

EventHandler.on(document, EVENT_SHOWN, SELECTOR_ACCORDION, function (e) {
  AccordionScroll.getOrCreateInstance(this)._onShown(e);
});

defineJQueryPlugin(AccordionScroll);

export default AccordionScroll;
